import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39f7a6e0")

_pushScopeId("data-v-39f7a6e0")
const _hoisted_1 = { class: "hitem hitem-left" }
const _hoisted_2 = { ref: "title" }
const _hoisted_3 = { class: "version" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  slot: "header",
  id: "modal-title"
}, "Log Out", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  slot: "content",
  class: "content"
}, " Are you sure you want to disconnect ? ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Cancel ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Confirm ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_calcite_button = _resolveComponent("calcite-button")
  const _component_calcite_modal = _resolveComponent("calcite-modal")

  return (_openBlock(), _createBlock("header", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", _hoisted_2, "GIS Data Management", 512),
      _createVNode("span", {
        class: "profile esri-icon-user",
        title: _ctx.role,
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.logOut()))
      }, null, 8, ["title"]),
      _createVNode("span", _hoisted_3, "v" + _toDisplayString(_ctx.appVersion), 1)
    ]),
    _createVNode(_component_calcite_modal, {
      ref: "confirmLogOut",
      "aria-labelledby": "modal-title",
      color: "blue"
    }, {
      default: _withId(() => [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_calcite_button, {
          slot: "secondary",
          width: "full",
          appearance: "outline",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.cancelLogOut()))
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_calcite_button, {
          slot: "primary",
          color: "red",
          ref: "confirmLogOutBtn",
          width: "full",
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.confirmLogOut()))
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 512)
  ]))
})